<template>
  <div
    class="scmcc-login-page"
    :style="{
      backgroundImage: `url(${envConst.SCMCC_HOST}/images/sign_bgtexture.png)`,
    }"
  >
    <div class="login-page-wrapper">
      <div class="content">
        <div class="scmcc-login-form-wrapper">
          <div :class="['errorInfo', { noShow: !errorInfo }]">
            {{ errorInfo }}
          </div>
          <div class="scmcc-login-logo">
            <img :src="`${envConst.SCMCC_HOST}/images/logo-login.svg`">
          </div>
          <Form class="scmcc-login-form" ref="formValidate" :model="loginForm">
            <FormItem
              v-if="tenants.length >= 0"
              class="scmcc-login-form-item"
              prop="domainName"
            >
              <i-input
                v-model="loginForm.domainName"
                filterable
                clearable
                placeholder="请输入域名"
                @on-enter="submitLoginForm"
              >
              </i-input>
            </FormItem>
            <FormItem class="scmcc-login-form-item" prop="username">
              <i-input
                v-model="loginForm.username"
                placeholder="请输入手机号/邮箱"
                @on-enter="submitLoginForm"
              ></i-input>
            </FormItem>
            <FormItem class="scmcc-login-form-item" prop="password">
              <i-input
                v-model="loginForm.password"
                :type="passwordHidden && 'password'"
                placeholder="请输入密码"
                @on-enter="submitLoginForm"
              >
                <template v-slot:suffix>
                  <img
                    class="scmcc-login-form-item-icon"
                    :src="
                      passwordHidden
                        ? require('../assets/images/login-page/ico_zhengyan_dis@2x.png')
                        : require('../assets/images/login-page/ico_biyan_dis@2x.png')
                    "
                    @click="passwordHidden = !passwordHidden"
                  />
                </template>
              </i-input>
            </FormItem>
            <FormItem
              v-if="needCheckCode"
              class="scmcc-login-form-item"
              prop="checkCode"
            >
              <i-input
                v-model="loginForm.checkCode"
                placeholder="请输入动态验证码"
                @on-enter="submitLoginForm"
              >
                <template v-slot:append>
                  <img
                    class="scmcc-login-form-item-checkcode"
                    :src="checkCodeUrl"
                    @click="getCheckCode"
                  />
                </template>
              </i-input>
            </FormItem>
            <FormItem class="scmcc-login-form-item lastly denglu-loading">
              <Button
                type="primary"
                long
                :loading="loading"
                @click="submitLoginForm"
                >登录</Button
              >
            </FormItem>
          </Form>
          <div class="link-text-box">
            <span @click="toRegister" v-if="false">立即注册</span>
            <span @click="toForget">忘记密码</span>
          </div>
        </div>
        <img
        v-if="false"
          class="form-image"
          :src="`${envConst.SCMCC_HOST}/images/pic.png`"
        />
      </div>
      <!-- <Modal
        v-model="arrearageFlag"
        width="400"
        title="停用通知"
        class="arrearage-tip"
      >
        <p style="padding-bottom: 40px">您的企业余额不足，坐席账号及业务人员账号已被限制登录，请联系管理员续费</p>
        <div slot="footer">
            <Button type="primary" size="large" @click="arrearageFlag=false">我知道了</Button>
        </div>
      </Modal> -->
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { stringify } from 'qs'
import envConst from '../env-const.js'
import { setTimeout } from 'timers'
import getPreData from '../getPreData.js'
import { pages } from '@/router/routes.js'
import stores from '@/store/'
import axios from 'axios'
import lazyLoadFile from '@/assets/lazyLoadFile.js'
export default {
  name: 'login',
  data: () => ({
    envConst,
    tenantName: '',
    checkCodeUrl: '',
    errorInfo: '',
    passwordHidden: true,
    needCheckCode: Cookies.get('needCheckCode'),
    loginForm: {
      domainName: '',
      username: '',
      password: '',
      checkCode: '',
    },
    tenants: [],
    lockTime: 0,
    loading: false,
    arrearageFlag: false,
  }),
  beforeRouteEnter(to, from, next) {
    // 如果URL上存在accessToken参数，则优先使用token登录
    if (to.query.accessToken) {
      axios
        .get(
          `${envConst.API_BASE_URL}/sctm/auth/tokenLogin?token=${to.query.accessToken}`,
          {
            withCredentials: true,
          }
        )
        .then(({ data }) => {
          if (data.rtnCode === '0') {
            axios
              .get(`${envConst.API_BASE_URL}/sctm/auth/loginSuccess`, {
                withCredentials: true,
              })
              .then((res) => {
                if (res.data.returnCode === 0) {
                  localStorage.sessionId = res.data.bean.sessionId
                  Cookies.remove('needCheckCode')
                  location.href = '/'
                }
              })
          } else {
            // next('/error')
            let errorMessage = data.rtnMsg
            // next({path:"/error",query:{errorMessage:"页面跳转成功"}})
            next('/error?errorMessage=' + errorMessage)
          }
        })
    } else {
      next()
    }
  },
  created() {
    // this.getTenant()
    this.getCheckCode()
    if (sessionStorage.isSqueezed === '1') {
      this.errorMesage('您的账号已在其他地方登录！')
      sessionStorage.isSqueezed = '0'
    } else if (sessionStorage.isLoginTimeout === '1') {
      this.errorMesage('登录信息已过期！')
      sessionStorage.isLoginTimeout = '0'
    }
    lazyLoadFile()
  },
  methods: {
    // 登录操作
    submitLoginForm() {
      // if (this.loginForm.domainName !== '') {
      //   if (
      //     typeof this.tenants.find(
      //       (item) => item.domainName == this.loginForm.domainName
      //     ) == 'undefined'
      //   ) {
      //     this.errorMesage('账号不存在或密码、域名错误')
      //     this.needCheckCode = true
      //     return
      //   }
      // }
      if (this.locked) return false
      this.loading = true
      // 调用登录接口
      this.$http
        .post('/sctm/auth/login', this.loginForm, {
          transformRequest: [
            (data) => {
              let _data = JSON.parse(JSON.stringify(data))
              _data.password = this.$encrypt.encrypt(data.password)
              return stringify(_data)
            },
          ],
        })
        .then((res) => {
          let { msgCode } = res.data.bean
          // 接口响应失败
          if (msgCode === 0) {
            this.$http('/sctm/auth/logOut').then(() => {
              this.$store.commit('main/user/clear')
              this.errorMesage(res.data.bean.msgMessage + '请重试')
              this.loading = false
              // this.submitLoginForm()
            })
          } else if (msgCode === 1) {
            localStorage.sessionId = res.data.bean.sessionId
            Cookies.remove('needCheckCode')
            window.localStorage.setItem('isArrears', res.data.bean.isArrears)
            // 判断灰度环境跳转之后刷新
            if (
              res.data.bean.userInfoBean &&
              res.data.bean.userInfoBean.hyyyVersion &&
              res.data.bean.userInfoBean.hyyyVersion == '0'
            ) {
              setTimeout(()=>{
                if(new RegExp("hyyy_version=hyyyx","g").test(document.cookie)){
                  this.$router.push('/')
                  window.location.href = '/'
                }else{
                  setTimeout(()=>{
                    this.$router.push('/')
                    window.location.href = '/'
                  },500)
                }
              },300)
              console.log('进入灰度环境')
              return
            }
            // 如果url有sourceOuterChain参数，则直接跳转
            if (this.$route.query.sourceOuterChain) {
              this.$http.get('/sctm/user/getLoginUser').then(({ data }) => {
                  localStorage.user = JSON.stringify({info: data.bean})
                  location.href = this.$route.query.sourceOuterChain
              })
              return
            }
            getPreData(this.$context).then(() => {
              // this.$router.push('/')
              this.$moduleLoader(this.$store.state.main.user.modules).then(
                () => {
                  this.$addRoutes(pages)
                  this.$store.commit('main/setModulesCompleted', true)
                  this.$config&&this.$config({store:this.$store})
                  this.$ws()
                  this.$router.push('/')
                }
              )
            })
          } else if (msgCode === 20014) {
            this.arrearageFlag = true
            this.loading = false
            return
          }
          else {
            this.loading = false
            if (res.data.bean.needCheckCode === '1') {
              this.getCheckCode()
              this.needCheckCode = true
              Cookies.set('needCheckCode', 1)
            }
            if (res.data.bean.isLocked === '1') {
              this.lockTime = res.data.bean.userErrLockedDate / 60
              let errorMesage =
                this.lockTime > 0
                  ? `该账号被锁定，${this.lockTime}分钟后可刷新重试`
                  : '该账号被锁定，请联系管理员'
              this.errorMesage(errorMesage)
            } else {
              this.errorMesage(res.data.bean.msgMessage)
            }
          }
        })
        .catch(e => {
          this.loading = false
          this.errorMesage('系统异常')
        })
    },
    // 获取验证码
    getCheckCode() {
      this.checkCodeUrl = `${
        envConst.API_BASE_URL
      }/sctm/checkCode/getCheckCode?t=${Date.now()}`
    },
    // 获取系统当前可用租户
    getTenant() {
      this.$http
        .get('/sctm/sctmtenantinfos/getTenantByState')
        .then(({ data }) => {
          if (data.returnCode === 0) {
            this.tenants = data.beans
            if (data.beans.length === 1) {
              this.loginForm.domainName = data.beans[0].domainName
            }
          }
        })
    },
    // 显示登录错误信息
    errorMesage(error) {
      this.errorInfo = error
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.errorInfo = ''
        this.timer = null
      }, 3000)
    },
    toRegister() {
      this.$router.push('./register')
    },
    toForget() {
      this.$router.push('./forget')
    },
  },
}
</script>

<style lang="stylus" scoped>
.scmcc-login-page
  height 100%
  width 100%
  overflow-y visible
  background #F3F6FC
  background-position center
  background-repeat no-repeat
  background-size 100% 100%

  .login-page-wrapper
    position relative
    width 100%
    // max-width 1440px
    // min-height 900px
    height 100%
    margin 0 auto

  .content
    display flex
    justify-content center
    align-items flex-end
    float left
    position relative
    width 50%
    text-align center
    margin-top calc(50vh - 280px)
    margin-left calc(25% - 0px)

  .scmcc-login-form-wrapper
    position relative
    display inline-block
    width 486px
    padding 46px 56px 56px 56px
    border-radius 8px
    background rgba(255,255,255,0.86)
    box-shadow 0 0 26px 0 rgba(47, 92, 184, 0.4)

    .errorInfo
      position absolute
      background #F8DDDC
      border-radius 8px
      text-align center
      line-height 52px
      width 100%
      height 52px
      font-size 16px
      color #E76461
      top 0
      left 0

      &.noShow
        display none

    .scmcc-login-logo
      display flex
      align-items center
      justify-content center
      margin 0 0 18px 0

      .scmcc-login-logo-text
        font-size 16px
        font-weight 600
        color rgba(54, 107, 187, 1)
        line-height 1
        margin-left 8px

    .link-text-box
      margin-top 24px
      // display flex
      color #04469D
      // justify-content space-between
      text-align center

      span
        cursor pointer

    .scmcc-login-form
      .scmcc-login-form-item
        margin-bottom 24px

        &.lastly
          margin-top 40px
          margin-bottom 0

        .ivu-select-selection
          height 52px

        >>> .ivu-select-input, >>> .ivu-input, .ivu-btn
          height 52px
          padding-left 20px
          color #515A6E
          font-size 16px

        >>> .ivu-input-icon, >>> .ivu-input-icon-clear 
          line-height 52px
        >>> .ivu-icon-ios-loading
          margin-top 10px
          line-height 32px
        .ivu-btn
          height 52px
          padding-left 20px
          font-size 20px
          color #ffffff
          border none

        .ivu-select-arrow
          right 12px
          color #BBC8D2

        .ivu-input-suffix
          display flex
          align-items center

          .scmcc-login-form-item-icon
            width 20px
            margin-top 16px

        >>> .ivu-input-group-append
          position relative
          padding 0
          width 120px
          overflow hidden

          .scmcc-login-form-item-checkcode
            position absolute
            top 0
            left 0
            height 100%
            width 100%

        .scmcc-login-form-item-domain
          padding 10px
          font-size 8px
      .denglu-loading
        >>>.ivu-icon-ios-loading
              margin-top 2px
      .ivu-form-item-label
        padding-bottom 7px
        padding-top 15px

      .scmcc-login-form-label
        display flex
        align-items center
        font-size 8px

        .scmcc-login-form-icon
          width 13px
          height 13px
          margin-right 4px
</style>
